import { Component, OnInit } from '@angular/core';
import { MealModel } from './mealmodel';
import { MealService } from '../meal.service';
import { GenericServiceService } from '../../services/generic-service.service';
import { ActivatedRoute, Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-new-meal',
  templateUrl: './add-new-meal.component.html',
  styleUrls: ['./add-new-meal.component.scss']
})
export class AddNewMealComponent implements OnInit {

  restId ;
  menuId ;
  model: any = {};
  mealmodel: MealModel = new MealModel();
  ingredientArray = [
    {
      Ingredient: {
        'Name': ''

      },
      IngredientTypes: [
        {
          'Name': ''
        }
      ]
    }
  ];

  Scalesarray = [
    {

      Scale: {
        'Name': '',
        'IsDefault': true,
        'MealId': ''
      },
      Units: [{
        'Name': '',
        'ScaleId': ''
      }]
    }];
    addonarray = [{
      addOns: {
        'Name': '',
        'Price': '',
        'IsSelected': true
      }
    }];
    mealMod = {
      'Meal': {
        'Name': '',
        'RestroId': 0,
        'Price': 0.0,
        'MealCategoryId': 0,
        'IsRecommend': true,
        'IsCustomDish': true,
        'ImageUrl': '',
        'IsFeatured': true,
        'MealMainId': 0,
        'Description': '',
        'Quantity': 0,
        'Discount': '',
        'Rating': 0,
        'TimeDuration': '',
        'Tags': ''
      },
      ingredients: [],
      Scales: [],
      addons: []
    };
    mealCategoryList: any = [];

  constructor(
    private mealService: GenericServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,

  ) { }

  ngOnInit() {
    this.getMealCategory();
    this.menuId = this.route.snapshot.paramMap.get('menuId');

    this.restId = this.route.snapshot.paramMap.get('restId');


  }
  getMealCategory() {
    this.mealService.GETMealCategories().subscribe(Response => {
      this.mealCategoryList = Response;
    });
  }
  onSubmit() {

    this.mealMod.Meal.Description = this.mealmodel.Description;
    this.mealMod.Meal.Discount = this.mealmodel.Discount;
    this.mealMod.Meal.Name = this.mealmodel.Name;
    this.mealMod.Meal.IsRecommend = this.mealmodel.IsRecommend;
    this.mealMod.Meal.IsCustomDish = this.mealmodel.IsCustomDish;
    this.mealMod.Meal.IsFeatured = this.mealmodel.IsFeatured;
    this.mealMod.Meal.Price = this.mealmodel.Price;
    this.mealMod.Meal.Quantity = this.mealmodel.Quantity;
    this.mealMod.Meal.Rating = this.mealmodel.Rating;
    this.mealMod.Meal.Tags = this.mealmodel.Tags;
    this.mealMod.Meal.RestroId = this.restId;
    this.mealMod.Meal.MealCategoryId = this.mealmodel.MealCategoryId;
    this.mealMod.Meal.MealMainId = this.menuId;
    this.mealService.addMeal(this.mealMod.Meal)
    .subscribe((data: any) => {
        this.toastr.success('Meal added...');
        // this.alert = true;
        this.router.navigateByUrl('/meals/' + this.restId + '/' + this.menuId );
        // this.toastr.error(data.Message);

    }, error => {
      // this.toastr.error(error.error.Message);
    });
  }

}
